import { CellContext } from '@tanstack/react-table';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip.tsx';
import { DestinationDto } from '@/features/dashboard/tours/types/DestinationDto.ts';
import {
  formatDestinationFull,
  splitDestination,
} from '@/features/dashboard/tours/types/DestinationDto.utils.ts';
import { CellSecondary } from '@/components/table/_fieldDefinitions/_base/CellSecondary.tsx';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

export const tourDestinationFieldRender = <T,>(
  info: CellContext<T, unknown>,
) => {
  const value = info.getValue() as DestinationDto | null;

  if (!value) return <EmptyValue />;

  const { main, secondary } = splitDestination(value);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="cursor-default">
          {main}
          <CellSecondary>{secondary}</CellSecondary>
        </span>
      </TooltipTrigger>
      <TooltipContent>{formatDestinationFull(value)}</TooltipContent>
    </Tooltip>
  );
};
